import { useEffect, useState } from "react";
import { Smartphone } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { api } from "@/lib/api";
import { currentSubscription, disablePush, enablePush, pushSupported } from "@/lib/push";

export const PushDeviceRow = () => {
  const [on, setOn] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => { currentSubscription().then((s) => setOn(!!s && Notification.permission === "granted")).catch(() => null); }, []);
  const toggle = async (v) => {
    setBusy(true);
    try {
      if (v) { await enablePush(); toast.success("Notifications activées sur cet appareil"); } else { await disablePush(); toast.success("Notifications désactivées sur cet appareil"); }
      setOn(v);
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  return (
    <li className="flex flex-wrap items-center gap-4 py-3" data-testid="push-device-row">
      <Smartphone className="h-5 w-5 text-primary" />
      <div className="min-w-0 flex-1"><div className="text-sm font-medium">Notifications sur cet appareil</div>
        <div className="text-xs text-muted-foreground">{pushSupported() ? "Alertes dans le centre de notifications du téléphone ou de l'ordinateur, même application fermée." : "Non disponible sur ce navigateur. Sur iPhone : Partager › Sur l'écran d'accueil, puis ouvrez CASHMY depuis l'icône."}</div></div>
      {on && <Button size="sm" variant="outline" className="rounded-full" onClick={() => api.post("/notifications/push/test").then(() => toast.success("Notification de test envoyée"))} data-testid="push-test">Tester</Button>}
      <Switch checked={on} disabled={busy || !pushSupported()} onCheckedChange={toggle} data-testid="push-toggle" />
    </li>
  );
};
